module.exports = __webpack_public_path__ + "static/media/10@720w.728e455b.jpg";